import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { Sidebar } from "@eudonet/opal";
import EudonetLogo from "../navBar/EudonetLogo.vue";
const transactionsIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath d='M2 12h2v9H2v-9zm3-5h2v14H5V7zm3-4h2v18H8V3zm3 7h2v11h-2V10zm3-5h2v16h-2V5zm3 2h2v14h-2V7z'/%3E%3C/svg%3E";
const subscriptionsIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M17 1l4 4-4 4'/%3E%3Cpath d='M3 11V9a4 4 0 014-4h14'/%3E%3Cpath d='M7 23l-4-4 4-4'/%3E%3Cpath d='M21 13v2a4 4 0 01-4 4H3'/%3E%3C/svg%3E";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sidebar',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const { t } = useI18n();
        // SVG data URIs for navigation icons
        const menuItems = computed(() => [
            {
                label: t("dashboard.menu.transactions"),
                icon: transactionsIcon,
                active: route.path.startsWith("/dashboard/transactions"),
                onClick: () => router.push("/dashboard/transactions"),
                children: [],
            },
            {
                label: t("dashboard.menu.subscriptions"),
                icon: subscriptionsIcon,
                active: route.path.startsWith("/dashboard/subscriptions"),
                onClick: () => router.push("/dashboard/subscriptions"),
                children: [],
            },
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Sidebar), {
                "data-testid": "dashboard-sidebar",
                items: menuItems.value,
                "model-value": true,
                theme: "dark"
            }, {
                logo: _withCtx(() => [
                    _createVNode(EudonetLogo, {
                        "logo-only": true,
                        class: "h-7 w-7 sidebar-logo-dark"
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items"]));
        };
    }
});
